import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'div[data-component-type=icon-check]',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckComponent implements OnInit {

  @Input() checked: boolean = false

  constructor() { }

  ngOnInit(): void {
  }

}
